import Header from './Header';
import React from 'react';
import { connect } from 'react-redux';
import { APP_LOAD, REDIRECT } from '../constants/actionTypes';
import { Route, Switch } from 'react-router-dom';
import Home from '../components/Home';
import { store } from '../store';
import { push } from 'react-router-redux';
import OuterBorders from './OuterBorders';
import Monuments from './Monuments'
import Black from './Black'
import BrownAndGray from './BrownAndGray'
import Boulders from './Boulders'
import Polished from './Polished'
import Borders from './Borders'
import { initializeLocalization } from '../translations';

const mapStateToProps = state => {
  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    redirectTo: state.common.redirectTo,
    lang: state.common.lang || 'LV'
  }};

const mapDispatchToProps = dispatch => ({
  onLoad: () =>
    dispatch({ type: APP_LOAD }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
  setLanguage: language => dispatch({ type: "SET_LANGUAGE", language })
});

class App extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      // this.context.router.replace(nextProps.redirectTo);
      store.dispatch(push(nextProps.redirectTo));
      this.props.onRedirect();
    }
  }

  componentWillMount() {    
        this.props.onLoad();
  }

  render() {
    initializeLocalization(this.props.lang);
    if (this.props.appLoaded) {
      return (
        <div>
          <Header
            appName={this.props.appName}
            language={this.props.lang}
            langFunc={this.props.setLanguage}
            />
            <Switch>
            <Route exact path="/" component={Home}/>
            <Route path="/outerborders" component={OuterBorders} />
            <Route path="/borders" component={Borders} />
            <Route path="/monuments" component={Monuments} />
            <Route path="/monuments-black" component={Black} />
            <Route path="/monuments-brownandgray" component={BrownAndGray} />
            <Route path="/monuments-boulders" component={Boulders} />
            <Route path="/monuments-polished" component={Polished} />            
            </Switch>
        </div>
      );
    }
    return (
      <div>
        <Header
          appName={this.props.appName}
          currentUser={this.props.currentUser} />
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js